<div class="offer-content-wrapper">
  <header class="d-flex align-items-baseline justify-content-between flex-wrap">
    <h2 class="offer-title mb-0">Offer Overview</h2>
    @if (offerConfirmationInfo() !== null) {
      <p class="mb-0">
        Offer accepted at {{ offerConfirmationInfo().confirmationDate | date : "shortTime" }}
        on {{ offerConfirmationInfo().confirmationDate | date : "MM/dd/yyyy" }}
      </p>
    }
  </header>
  @if (offerConfirmationInfo() !== null && showPerformanceSummary) {
  <div class="pegasus-credit-summary my-5">
    <h2>Your Estimated {{ creditPercentage }} Credit</h2>
    <div class="program-name">Beyfortus Partners Plus Program</div>

    <div>
      <div class="projected-rebate-title">Projected Credit<sup>*</sup></div>
      <div class="projected-rebate-amount">
        {{ creditAmount | currency:'USD':'symbol':'1.0-0' }}
      </div>
    </div>

    <hr />

    <div class="row text-center">
      <div class="col-12 col-sm-4 mb-3 mb-sm-0">
        <div class="label">Scheduled Doses</div>
        <div class="value">{{ scheduledDoses }}</div>
      </div>
      <div class="col-12 col-sm-4 mb-3 mb-sm-0">
        <div class="label">Shipped Doses</div>
        <div class="value">{{ shippedDoses }}</div>
      </div>
      <div class="col-12 col-sm-4">
        <div class="label">Total Purchase</div>
        <div class="value">{{ totalPurchase | currency:'USD':'symbol':'1.0-0' }}</div>
      </div>
    </div>

    <div class="last-updated">
      Last Updated: {{ lastUpdated | date : 'MMMM d, y' }}
    </div>

    <p class="disclaimer">
      <sup>*</sup> The credit amount shown is an estimate based on available sales data and assumes the customer meets all eligibility criteria as outlined in the offer terms and conditions. Credits will be paid if all criteria are met and the customer retains eligibility throughout the 3-year commitment period, based on the selected rebate option (e.g., 2% annually or 7% at the end of 3 years).</p>
  </div>
  }
  <div class="mt-5" [innerHTML]="offer.offerDescription | safe : 'html'"></div>

  @for (document of offer.documents; track $index) {
    <app-offer-document [document]="document" [baseurl]="baseurl" />
  }



  <h2 class="offer-form-title mb-0">Acceptance of Offer</h2>
  <div class="border-bottom pb-5 form-wrapper">
    @if (offerConfirmationInfo() !== null) {
      <div class="d-flex text-violet mt-4">
        <img src="assets/icons/vsh/checkmark.svg" alt="" class="mr-1" />
        <p class="mb-0">
          <span class="d-block font-weight-bold">Congratulations!</span>
          <span class="congratulation-message">
            {{ offerConfirmationInfo().acceptedOfferTraitName }} has been accepted at
            {{ offerConfirmationInfo().confirmationDate | date : "shortTime" }} on
            {{ offerConfirmationInfo().confirmationDate | date : "MM/dd/yyyy" }}.
          </span>
        </p>
      </div>
    } @else {
      <app-offer-form
        [offer]="offer"
        [user]="user"
        (offerFormSubmission)="confirmOffer($event)"
      />
    }
  </div>

  @if (offerConfirmationInfo() !== null) {
    <p class="mt-5 mb-0">{{ offer.successMessage }}</p>

    @for (redirectionLink of offer.redirectionLinks; track $index) {
      <a
        [href]="redirectionLink.url"
        class="text-decoration-none mt-4 d-block redirection-links"
        [ngClass]="{
          'btn-primary': redirectionLink.primary,
          'btn-secondary': !redirectionLink.primary
        }"
      >
        {{ redirectionLink.linkText }}
      </a>
    }
  }

  @if (showToastNotification()) {
    <div
      class="toast-notification d-flex align-items-center justify-content-between mt-4"
    >
      <p class="mb-0">
        <img src="assets/icons/confirmation-positive-green.png" alt="" />
        Offer has been accepted.
      </p>

      <button
        class="border-0 bg-transparent p-0"
        aria-label="close confirmation notification"
        (click)="closeToastNotification()"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  }
</div>
